export { ChangePasswordConfirmModal } from './ChangePasswordConfirmModal';
